import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import cssVars from 'css-vars-ponyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter as Router } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import 'font-awesome/css/font-awesome.min.css';
import 'react-toastify/dist/ReactToastify.css';
import ReactPiwik from 'react-piwik';
import * as serviceWorker from './serviceWorker';
import { handleAppInit } from './store/actions/appActions';
import configureStore from './store/configureStore';
import App from './App';
import './index.scss';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

store.dispatch(handleAppInit());

const rootElement = document.getElementById('root');

const piwik = new ReactPiwik({
  url: 'matomo.selectmedical.com',
  siteId: 26,
  trackErrors: true,
});

ReactPiwik.push(['enableHeartBeatTimer']);
ReactPiwik.push(['trackPageView']);

cssVars({
  onlyLegacy: false,
});

ReactDOM.render(
  <Provider store={store}>
    <Router history={piwik.connectToHistory(history)}>
      <App />
    </Router>
  </Provider>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
